import { inject, Injectable } from "@angular/core";
import { MODELNAME, SignupConsorcistaToken } from "./consorcistaTokens.config";
import { CrudService } from "@shared/modules/crud/crud.service";

@Injectable({
    providedIn: 'root',
})
export class consorcistasTokenService {
    model = MODELNAME;
    crudService = inject(CrudService)

    getTokenByCod(code: string) {
        this.crudService.setModel(this.model)
        const filter: any = [{
            field: 'cod',
            operator: '==',
            value: code,
        }];

        return this.crudService.findOneWhere<SignupConsorcistaToken>(filter, []);

    }

    create(data: Partial<SignupConsorcistaToken>) {
        this.crudService.setModel(this.model);
        return this.crudService.add(data);
    }

    createTest() {
        let testToken: Partial<SignupConsorcistaToken> = {
            createdAt: new Date(),
            cod: "a123asd",
            consorcioId: '2EByW14cN8feSBspDeRc',
            administrationId: 'wVnRFijE7laNKtcuNDTuddKBD0w1'

        }
        this.crudService.setModel(this.model);
        this.crudService.add(testToken)
    }

    delete(tokenId: string) {
        this.crudService.setModel(this.model);
        const path = this.model + '/' + tokenId;
        this.crudService.setModel(path);
        return this.crudService.delete('');
    }


}
